import { useCallback, useEffect, useRef } from 'react';

export const useAbortableRequest = () => {
  const controllerRef = useRef(null);
  const requestIdRef = useRef(0);

  const beginRequest = useCallback(() => {
    if (controllerRef.current) controllerRef.current.abort();

    const controller = new AbortController();
    controllerRef.current = controller;
    requestIdRef.current += 1;

    return { signal: controller.signal, requestId: requestIdRef.current };
  }, []);

  const isLatest = useCallback((requestId) => requestId === requestIdRef.current, []);

  useEffect(() => {
    return () => {
      if (controllerRef.current) controllerRef.current.abort();
    };
  }, []);

  return { beginRequest, isLatest };
};

